import type { AdviserRole } from '../types';

interface AdviserRoleDisplay {
  label: string;
  className: string;
}

export const getAdviserRoleDisplay = (
  adviserRole: AdviserRole | null | undefined,
): AdviserRoleDisplay => {
  if (adviserRole === 'AUTHORISED_REP') {
    return { label: 'Authorised Rep', className: 'bg-amber-100 text-amber-800' };
  }
  if (adviserRole === 'QUOTING_ADVISER') {
    return { label: 'Quoting Adviser', className: 'bg-blue-100 text-blue-800' };
  }
  if (adviserRole === 'INTERNAL_ADVISER') {
    return { label: 'Internal Adviser', className: 'bg-purple-100 text-purple-800' };
  }

  return { label: 'Not Set', className: 'bg-slate-200 text-slate-600' };
};
